import "./App.scss";
import "assets/styles/mixins/BO.scss";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import Router from "./Router";
import { ToastContainer } from "react-toastify";
import MsalTokenForwarder from "api/user/MsalTokenForwarder";

export default function App() {
  return (
    <div className="App">
      <ToastContainer />
      <MsalTokenForwarder>
        <Router />
      </MsalTokenForwarder>
    </div>
  );
}
